import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { api } from "../../../../app/applicationSlice";
import { RootState, RootThunk } from "../../../../app/store";
import * as service from "../../../../services/drugStaticModel";
import { drugStaticParams } from "../../../../services/drugStatic";

interface modelDetail {
  detail: [];
  Total: 0,
  Current: 1,
}

const initialState = {
  detail: [],
  Total: 0,
  Current: 1,


} as modelDetail;

const drugStaticDetailSlice = createSlice({
  name: "model",
  initialState,
  reducers: {

    setTotal(state, action) {
      state.Total = action.payload
    },
    setCurrent(state, action) {
      state.Current = action.payload
    },
    setDetail(state, action) {
      state.detail = action.payload
    },
  },
});

export const { setTotal, setCurrent, setDetail, } = drugStaticDetailSlice.actions;

export const selectDetail = (state: RootState) => state.drugStaticModelDetail.detail

export const selectTotal = (state: RootState) => state.drugStaticModelDetail.Total

export const selectCurrent = (state: RootState) => state.drugStaticModelDetail.Current

export function getDrugStaticDetailList(params: drugStaticParams): RootThunk {
  return api(service.getDrugStaticDetail(params), (data: any, dispatch) => {
    dispatch(setDetail(data.records))
    dispatch(setTotal(data.total))
  });
}



export default drugStaticDetailSlice.reducer;
